export enum DanceClassRulesEnum {
  MUST_CONFIRM_ATTENDEE = "MUST_CONFIRM_ATTENDEE",
  FIXED_PAIRS = "FIXED_PAIRS",
  QUEUE_ACTIVE = "QUEUE_ACTIVE",
  LEADER_FOLLOWER_OPTION = "LEADER_FOLLOWER_OPTION",
  ALLOW_SELF_CHECKIN = "ALLOW_SELF_CHECKIN",
  GENDER_RESTRICTION = "GENDER_RESTRICTION",
  AGE_RESTRICTION = "AGE_RESTRICTION"
}
